import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LocalMallIcon from '@material-ui/icons/LocalMall';
// import StorageIcon from '@material-ui/icons/Storage';
import ClientHomeView from './views/ClientHomeView';

const BASE_URL = '/#/';

function ClientHomePage({ currentLanguage }) {
    const clientLanguage = currentLanguage.bepiService.client;

    const cards = useMemo(
        () => [
            {
                id: 'quote-service',
                title: clientLanguage.client_home_quote_service_card,
                url: `${BASE_URL}bepi/client/quote`,
                Icon: ListAltIcon,
            },
            {
                id: 'service-status',
                title: clientLanguage.client_home_my_quotations_card,
                url: `${BASE_URL}bepi/client/quotations`,
                Icon: LocalMallIcon,
            },
            // {
            //     id: 'my-equipments',
            //     title: clientLanguage.client_home_my_equipments_card,
            //     url: `${BASE_URL}bepi/client/equipaments`,
            //     Icon: StorageIcon,
            // },
        ],
        [clientLanguage]
    );

    return (
        <ClientHomeView
            cards={cards}
            pageTitle={clientLanguage.client_home_welcome_question}
            currentLanguage={currentLanguage}
        />
    );
}

ClientHomePage.propTypes = {
    currentLanguage: PropTypes.object.isRequired,
};

export default withRouter(ClientHomePage);
